import { DropdownMenuSelect } from '../../DropdownMenuSelect';
import { AgeGroups } from './constants';

export function AgeSelect(props: {
  onSelect: (val: string) => void;
  val: string;
}) {
  return (
    <DropdownMenuSelect
      onSelect={props.onSelect}
      val={props.val}
      values={AgeGroups.map((age) => ({
        label: age === '18+' ? '18+' : `${age}U`,
        value: age,
      }))}
      defaultLabel="Choose an age group"
    />
  );
}
